var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"space-y-1"},_vm._l((_vm.options),function(option,index){return _c('GroupSelectorItem',{key:index,attrs:{"label":option.label,"is-current":_vm.value === index,"meta":_vm.metaByCategory[index]},on:{"click":function($event){return _vm.$emit('input', index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }